
import "./IntegrationCodeLine.css"

import NiceModal from '@ebay/nice-modal-react';
import { useAuthDispatchContext } from '/src/features/auth/context/authContext';
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
import IntegrationShowModal from "../IntegrationShowModal/IntegrationShowModal";
import capitalizeFirstLetter from "/src/utils/capitalizeFirstLetter";
import { env } from "/src/var/env";
import hasPermission from "/src/utils/hasPermission";
import { isPwa } from "/src/utils/isPwa";

function IntegrationCodeLine({ integration, text, handleDelete }) {
    const toast = useToastDispatchContext();
    const showIntegrationShowModal = (integration) => NiceModal.show(IntegrationShowModal, { integration: integration })
    
    const url_path = integration.integration_type_id == 3 ? "dataset" : "faq";
    const url_main = `${env.REACT_APP_API_PATH.split("/api/v1")[0]}/${url_path}/api?key=`;
    const url_question = integration.integration_type_id == 3 ? "" : "&question=Hello";

    const full_url = url_main +integration.api_key + url_question;
    
    return (
        <div className="integration" key={integration.api_key}>
            <div>
                <span className={"flag-icon flag-icon-" + integration.language.slug.toLowerCase()}></span>
                <span className="integration_name"> {capitalizeFirstLetter(integration.name)} </span>
            </div>
            <pre className="pre code code-url">
                <code onClick={(e) => navigator.clipboard.writeText(text).then(_ => { toast.success('Copy link to clipboard', 'You can paste this link where you need !'); })}>
                    {url_main}<span style={{fontWeight: '900'}}>{integration.api_key}</span>{url_question}
                </code>
            </pre>
            <div className="actions-integration show">
            <i className="fas fa-copy add-hover" aria-hidden="true" onClick={(e) => navigator.clipboard.writeText(full_url).then(_ => { toast.success('Copy link to clipboard', 'You can paste this link where you need !',5000); })}></i>
            <i className="fas fa-key add-hover" aria-hidden="true" onClick={(e) => navigator.clipboard.writeText(integration.api_key).then(_ => { toast.success('Copy API Key to clipboard', 'You can paste this api key where you need !',5000); })}></i>
                <a href={full_url} style={{ display: "flex" }} target={isPwa() ? '_self' : '_blank'}> <i className="fas fa-link add-hover" aria-hidden="true"> </i> </a>
                <i className="fas fa-eye add-hover" aria-hidden="true" onClick={() => showIntegrationShowModal(integration)}></i>
                {handleDelete != null && hasPermission('delete_integration') ?
                    <i className="fas fa-trash remove-hover" aria-hidden="true" onClick={() => handleDelete(integration)}></i>
                    :
                    null
                }


            </div>
        </div>
    );
}
export default IntegrationCodeLine;